/**
 * Helper para manejar descargas de archivos desde el backend
 */

/**
 * Descarga un archivo blob con el nombre especificado
 * @param {Blob} blob - El blob del archivo
 * @param {string} filename - Nombre del archivo a descargar
 */
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Extrae el nombre del archivo desde los headers de respuesta
 * @param {Object} response - Respuesta de axios
 * @returns {string} - Nombre del archivo o nombre por defecto
 */
export const getFilenameFromResponse = (response) => {
  // Buscar el header content-disposition tanto en mayúsculas como minúsculas
  const contentDisposition = 
    response.headers['content-disposition'] ||
    response.headers['Content-Disposition'] ||
    response.headers.contentDisposition;
    
  console.log('Content-Disposition header:', contentDisposition);
  console.log('All headers:', response.headers);
  
  if (contentDisposition) {
    // Buscar filename con comillas dobles: filename="archivo.xlsx"
    let filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
    if (filenameMatch) {
      console.log('Extracted filename with quotes:', filenameMatch[1]);
      return filenameMatch[1];
    }
    
    // Buscar filename sin comillas: filename=archivo.xlsx
    filenameMatch = contentDisposition.match(/filename=([^\s;]+)/);
    if (filenameMatch) {
      console.log('Extracted filename without quotes:', filenameMatch[1]);
      return filenameMatch[1];
    }
  }
  
  console.log('Using default filename: reporte.xlsx');
  return 'reporte.xlsx';
};

/**
 * Maneja la descarga de reportes Excel desde la API
 * @param {Function} apiCall - Función que hace la llamada a la API
 * @param {Object} params - Parámetros para la API
 * @param {string} defaultFilename - Nombre por defecto si no se puede extraer
 * @returns {Promise} - Promise que resuelve cuando la descarga inicia
 */
export const downloadExcelReport = async (apiCall, params, defaultFilename = 'reporte.xlsx') => {
  try {
    const response = await apiCall(params);
    const filename = getFilenameFromResponse(response) || defaultFilename;
    downloadBlob(response.data, filename);
    return { success: true, filename };
  } catch (error) {
    console.error('Error al descargar reporte:', error);
    let detail = error.message;
    if (error.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        try {
          const j = JSON.parse(text);
          detail = j.message || j.detail || text;
        } catch {
          detail = text || detail;
        }
      } catch {
        detail = error.message;
      }
    } else if (error.response?.data?.message) {
      detail = error.response.data.message;
    } else if (error.response?.data?.detail) {
      detail =
        typeof error.response.data.detail === 'string'
          ? error.response.data.detail
          : JSON.stringify(error.response.data.detail);
    }
    throw new Error('Error al descargar el reporte: ' + detail);
  }
};
